// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"84eaa358","239":"ec708afe","305":"305f7252","317":"8a95c217","381":"55389595","455":"ceadcd10","940":"7a9e7580","973":"15e57b63","977":"3bc3d136"}[chunkId] + ".chunk.js";
};